import * as React from 'react';
import { QRCode } from 'react-qr-svg';
import Text from '../../../shared/Text';
import { Box, Link, TextField, Typography } from '@mui/material';
import { createElementsFromText } from 'html-text-to-react';

const LINK_GA_IOS_URL = 'https://itunes.apple.com/us/app/google-authenticator/id388497605';
const LINK_GA_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const LINK_AUTH_FIREFOX_URL =
  'https://addons.mozilla.org/en-US/firefox/addon/auth-helper/?src=external-website';
const LINK_AUTH_CHROME_URL =
  'https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai';
const LINK_AUTH_EDGE_URL =
  'https://microsoftedge.microsoft.com/addons/detail/authenticator/ocglkepbibnalbgmbachknglpdipeoio';

export const LoginSetupTotpDetails: React.FC = () => (
  <Box whiteSpace="nowrap">
    <Typography variant="body2">
      <strong>{Text.get('login_totp_config_step1_details')}</strong>
    </Typography>
    <div>
      <Typography variant="body2">
        {Text.get('login_totp_config_step1_app')} —{' '}
        <Link href={LINK_GA_IOS_URL} target="_blank">
          {Text.get('login_totp_config_device_ios')}
        </Link>{' '}
        |{' '}
        <Link href={LINK_GA_ANDROID_URL} target="_blank">
          {Text.get('login_totp_config_device_android')}
        </Link>
      </Typography>
    </div>
    <div>
      <Typography variant="body2">
        {Text.get('login_totp_config_step1_browser')} —{' '}
        <Link href={LINK_AUTH_FIREFOX_URL} target="_blank">
          {Text.get('login_totp_config_browser_firefox')}
        </Link>{' '}
        |{' '}
        <Link href={LINK_AUTH_CHROME_URL} target="_blank">
          {Text.get('login_totp_config_browser_chrome')}
        </Link>{' '}
        |{' '}
        <Link href={LINK_AUTH_EDGE_URL} target="_blank">
          {Text.get('login_totp_config_browser_edge')}
        </Link>
      </Typography>
    </div>
  </Box>
);

export const LoginSetupTotpAddAccountDetails: React.FC<{
  totpSecret: string;
  totpKeyUri: string;
}> = ({ totpSecret, totpKeyUri }) => (
  <div>
    <div>
      <Typography variant="body2">
        {createElementsFromText(Text.get('login_totp_config_step2_opt1_or_enter'))}
      </Typography>
      <Typography variant="body2">
        <strong>{totpSecret}</strong>
      </Typography>
    </div>
    {/* render SVGs without blurry borders */}
    <Box mt={2} sx={{ transform: 'rotate(0.01deg)' }}>
      <QRCode level="L" value={totpKeyUri} />
    </Box>
  </div>
);

export const LoginStepTotpCodeInputArea: React.FC<{
  isTotpInvalid: boolean;
  isFormDisabled: boolean;
  onChangeTotp: (event: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ isTotpInvalid, isFormDisabled, onChangeTotp }) => (
  <div>
    <TextField
      autoFocus
      data-test="totp-code"
      disabled={isFormDisabled}
      error={isTotpInvalid}
      helperText={
        <>
          {Text.get('login_totp_config_step3_description')}
          {isTotpInvalid && <div>{Text.get('login_totp_config_step3_error')}</div>}
        </>
      }
      id="totp-code"
      inputProps={{ maxLength: 6 }}
      onChange={onChangeTotp}
      size="small"
    />
  </div>
);
